import RequestHistory from './RequestHistory';

export default RequestHistory;